// CMS GTM event for color picker
export const gtmEventTypes = {
  CLICK_COLOR: 'CMS-MINICONFIGURATOR-001',
  CLICK_CTA: 'CMS-MINICONFIGURATOR-002',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_COLOR]: ({CMSGroupGTM, color}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_COLOR,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${color.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_CTA]: ({CMSGroupGTM, ctaLabel}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${ctaLabel.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mini-configurator-duck.js